import { lazy, Suspense } from 'react';

import { Modal } from '@/components/ui/Modal';
import { Button } from '@/components/ui/Button';

interface DataConsentProps {
  isOpen: boolean;
  onClose: () => void;
}

/**
 * M2 — Согласие на обработку персональных данных.
 * Источник: docs/legal/data_consent.md.
 * Lazy-load (см. PrivacyPolicy.tsx).
 */
const DataConsentContent = lazy(() => import('./legal/DataConsentContent'));

export function DataConsent({ isOpen, onClose }: DataConsentProps) {
  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Согласие на обработку ПДн">
      <div className="flex flex-col gap-3">
        <Suspense fallback={<LegalContentFallback />}>
          {isOpen && <DataConsentContent />}
        </Suspense>
        <div className="pt-2">
          <Button onClick={onClose} fullWidth size="md">
            Понятно
          </Button>
        </div>
      </div>
    </Modal>
  );
}

function LegalContentFallback() {
  return (
    <div className="flex justify-center py-8" aria-label="Загрузка текста">
      <span
        role="status"
        className="inline-block h-8 w-8 animate-spin rounded-full border-2 border-border border-t-accent"
      />
    </div>
  );
}
